import React from 'react';
import { useNavigate } from 'react-router-dom';
import { colors, fonts } from '../brand';
import SiteNav from '../components/SiteNav';
import Disclaimer from '../components/Disclaimer';
import SiteFooter from '../components/SiteFooter';

export default function BackInCourt() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <SiteNav />
      <main style={styles.main}>
        <div style={styles.inner}>
          <p style={styles.eyebrow}>BACK IN COURT</p>
          <h1 style={styles.title}>A Roadmap For Your Situation Is Coming Soon</h1>
          <p style={styles.subtitle}>
            Your situation is different — and it deserves its own support. We're working on it.
            In the meantime, here's where to go next.
          </p>
          <div style={styles.buttons}>
            <button style={styles.btnPrimary} onClick={() => navigate('/listen')}>Listen</button>
            <button style={styles.btnSecondary} onClick={() => navigate('/contact')}>Contact Us</button>
            <button style={styles.btnSecondary} onClick={() => navigate('/dashboard')}>Dashboard</button>
          </div>
        </div>
      </main>
      <Disclaimer />
      <SiteFooter />
    </div>
  );
}

const styles = {
  page: { fontFamily: fonts.body, backgroundColor: colors.cream, minHeight: '100vh' },
  main: { padding: '80px 20px' },
  inner: { maxWidth: '600px', margin: '0 auto', textAlign: 'center' },
  eyebrow: { fontFamily: fonts.body, color: colors.rose, fontSize: '11px', letterSpacing: '2.5px', textTransform: 'uppercase', marginBottom: '16px' },
  title: { fontFamily: fonts.heading, color: colors.navy, fontSize: '32px', fontWeight: '600', lineHeight: '1.4', marginBottom: '20px', letterSpacing: '0.3px' },
  subtitle: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '15px', lineHeight: '1.9', marginBottom: '40px' },
  buttons: { display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' },
  btnPrimary: { padding: '14px 32px', backgroundColor: colors.rose, color: colors.white, border: 'none', fontSize: '14px', fontFamily: fonts.body, fontWeight: '600', cursor: 'pointer', letterSpacing: '0.5px' },
  btnSecondary: { padding: '14px 32px', backgroundColor: 'transparent', border: `1px solid ${colors.navy}`, color: colors.navy, fontSize: '14px', fontFamily: fonts.body, fontWeight: '600', cursor: 'pointer', letterSpacing: '0.5px' },
};
